var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0601 8.38825L13.3939 12.3883C13.3025 12.5252 13.1788 12.6374 13.0337 12.715C12.8886 12.7926 12.7266 12.8333 12.562 12.8333H2.72888C2.63766 12.8333 2.54817 12.8083 2.47012 12.7611C2.39207 12.7139 2.32841 12.6462 2.28606 12.5654C2.2437 12.4846 2.22425 12.3938 2.22981 12.3027C2.23538 12.2117 2.26575 12.1239 2.31763 12.0489L5.22888 7.83325L2.31763 3.61763C2.26575 3.5426 2.23538 3.4548 2.22981 3.36375C2.22425 3.2727 2.2437 3.18187 2.28606 3.10108C2.32841 3.02029 2.39207 2.95263 2.47012 2.90542C2.54817 2.85821 2.63766 2.83325 2.72888 2.83325L12.562 2.83325C12.7266 2.83325 12.8886 2.87386 13.0337 2.95149C13.1788 3.02911 13.3025 3.14135 13.3939 3.27825L16.0601 7.27825C16.1698 7.44258 16.2283 7.6357 16.2283 7.83325C16.2283 8.0308 16.1698 8.22392 16.0601 8.38825Z",
    fill: "#00B2A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/deviceIcon.382e123b9520ac2a86509163beabaabb.svg";
export { ForwardRef as ReactComponent };